<template>
  <v-card flat color="transparent" class="pa-4">
    <v-row align="center" class="mb-2">
      <v-col cols="12" md="8">
        <h2 class="font-weight-bold">Producción</h2>
        <p class="grey--text mb-0">Gestioná recetas, máquinas y órdenes de producción.</p>
      </v-col>
      <v-col cols="12" md="4" class="text-md-right">
        <v-btn color="deep-purple" dark :to="{ name: 'empresa.produccion.orden.registrar' }">
          <v-icon left>mdi-plus</v-icon>
          Nueva orden de producción
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col v-for="card in cards" :key="card.name" cols="12" md="4">
        <v-card class="hoverable fill-height" @click="$router.push({ name: card.name })" outlined>
          <v-card-text class="text-center py-8">
            <v-avatar :color="card.color" size="64" class="mb-4">
              <v-icon dark size="34">{{ card.icon }}</v-icon>
            </v-avatar>
            <h3 class="subtitle-1 font-weight-bold">{{ card.title }}</h3>
            <p class="caption grey--text mb-0">{{ card.desc }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12">
        <v-alert text type="info" border="left" color="deep-purple">
          <strong>Tip:</strong> desde una <em>orden de preparación</em> (Ventas) podés ver el
          <strong>plan de producción sugerido</strong>: qué recetas y cuántas placas se necesitan
          para cubrir el pedido, descontando el stock.
        </v-alert>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'ProduccionEmpresaDash',
  data() {
    return {
      cards: [
        {
          name: 'empresa.produccion.cola',
          title: 'Cola de producción',
          desc: 'Lo que hay que cortar ahora. Confirmá al producir.',
          icon: 'mdi-clipboard-play-outline',
          color: 'deep-purple',
        },
        {
          name: 'empresa.produccion.plan',
          title: 'Plan de producción',
          desc: 'Qué falta producir para cubrir los pedidos.',
          icon: 'mdi-clipboard-list-outline',
          color: 'indigo darken-1',
        },
        {
          name: 'empresa.produccion.orden.listado',
          title: 'Órdenes de producción',
          desc: 'Historial y alta manual de órdenes.',
          icon: 'mdi-factory',
          color: 'deep-purple',
        },
        {
          name: 'empresa.produccion.receta.listado',
          title: 'Recetas / Programas',
          desc: 'Qué consume y qué produce cada programa.',
          icon: 'mdi-clipboard-text-outline',
          color: 'indigo',
        },
        {
          name: 'empresa.produccion.maquina.listado',
          title: 'Máquinas',
          desc: 'Costo por minuto de cada recurso.',
          icon: 'mdi-robot-industrial',
          color: 'blue-grey',
        },
      ],
    };
  },
};
</script>

<style scoped>
.hoverable {
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.hoverable:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18) !important;
  transform: translateY(-2px);
}
</style>
